




























































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
import { mapServer } from '../../../src/api/installService';
import SearchEnterprises from '@/views/searchEnterprise/SearchEnterprise.ts';
import nearbySearch from '@/views/NearbySearch/NearbySearch.ts';
import { ElCollapseItem } from 'element-ui/types/collapse-item';
import publishObjectPath from '@/util/configRegistry';
import { Tree } from 'element-ui';
// import {store} from '../../store/index';

@Component({
  name: 'NearbySearch',
  components: {},
  mixins: [MapResolver],
})
export default class NearbySearch extends Vue {
  @Injectable() public container!: Container;
  private SearchRes: any = [];
  private loading: boolean = false;
  private enterpriseInfo: any = '';
  private isSearching: boolean = false;
  private EnterpriseList: any = [
    '企业',
  ];
  private wit: any = [];
  private selectDialog: boolean = false;
  private tagVal: any = 1;
  private tableData: any = [];
  private showInfoPushDetail: any = '';
  private upLoadPath: any = publishObjectPath.value.upLoadPath;
  private AdDetail: any = {};
  private img_list: any = [];
  private tableTitle: any = [
    {
      prop: 'title',
      label: '标题',
    },
    {
      prop: 'informationName',
      label: '信息分类',
    },
    {
      prop: 'createTime',
      label: '发布时间',
    },
  ];
  private detailId: any = '';
  private totalInfo: any = 0;
  private totalInfoPage: any = 0;
  private currentInfoPage: any = 0;
  private countNum: any = [
    {
      name: '企业',
      num: 15,
    },
  ];
  private reasch: any = {
    class: ['企业', '楼宇', '设备'],
    fta: [],
    characteristic: [
      {
        value: '内资',
        parentId: null,
        label: '内资',
        parentLabel: null,
        disabled: false,
        children: null,
        orgTypeCode: 0,
        virtualNode: false,
        leaf: false,
      },
      {
        value: '外资',
        parentId: null,
        label: '外资',
        parentLabel: null,
        disabled: false,
        children: null,
        orgTypeCode: 0,
        virtualNode: false,
        leaf: false,
      },
      {
        value: '1',
        parentId: null,
        label: '重点',
        parentLabel: null,
        disabled: false,
        children: null,
        orgTypeCode: 0,
        virtualNode: false,
        leaf: false,
      },
      {
        value: '2',
        parentId: null,
        label: '非重点',
        parentLabel: null,
        disabled: false,
        children: null,
        orgTypeCode: 0,
        virtualNode: false,
        leaf: false,
      },
    ],
    classify: [],
    typeList: [],
  };
  private total: any = '';
  private totalEnterprise: any = '';
  private totalShop: any = '';
  private totalPark: any = '';
  private totalFacility: any = '';
  private nowPage: any;
  private pageSize: any;
  private totalPages: any;
  private SearchResParamsForFreeTradeZone: any = [];
  private SearchResParamsForCharacteristic: any = [];
  private SearchResParamsForClassify: any = [];
  private SearchResParams: any = {
    creditCodeOrName: '',
    endTime: '',
    enterpriseId: '',
    enterpriseType: '',
    freeTradeZone: '',
    industryClass: '',
    industryCode: '',
    isKeyEnterprises: '',
    nowPage: 1,
    pageSize: 10,
    startTime: '',
  };
  private dialogTableVisibleEnterpriseImage: boolean = false;
  private legendData: any = '';
  private eyeFlag: any = [false, false, false, false, false];
  private minFalg: boolean = true;
  private color: any = [
    {
      backgroundColor: '#33cc00',
    },
    {
      backgroundColor: '#feff01',
    },
    {
      backgroundColor: '#fe0000',
    },
    {
      backgroundColor: '#0000fe',
    },
    {
      backgroundColor: '#ff009a',
    },
  ];
  private dialogTableVisiblearea: boolean = false;
  private areaInfo: any = {
    title: '',
    info: '',
  };
  private isActive: boolean = false;
  // 已选
  private selectList: any = [];

  // 门类
  private categoryList: any = [];
  private category: any = [];
  private defeatCheck: any = [];
  private categoryListSelect: any = '';
  // 大类
  private categoryListbig: any = [];
  private categorybig: any = [];
  private bigdefeatCheck: any = [];
  private categoryListbigSelect: any = '';
  // 中类
  private categoryListmid: any = [];
  private categorymid: any = [];
  private middefeatCheck: any = [];
  private categoryListmidSelect: any = '';
  // 小类
  private categoryListsmall: any = [];
  private categorysmall: any = [];
  private smalldefeatCheck: any = [];
  private categoryListsmallSelect: any = '';

  private msgObj: any = null;
  private nearbySearchs: any;

  // 根据门类数据，获取 大类、中类、小类数据
  private souceData: any = [];
  private SearchEnterpriseqh: any;
  private geometry: any;
  constructor() {
    super();
  }

  /*翻页*/
  public handleCurrentChange(val: number) {
      this.SearchResParams.nowPage = val;
      this.loading = true;
      this.FnSearchRes(false);
  }
  private infoPushClose() {
    this.showInfoPushDetail = '';
  }

  /* 标绘 */
  private PlotPoint() {
    this.nearbySearchs.clearResourceLayer();
    this.nearbySearchs.DrawPoint(3, (data: any) => {
      data = JSON.stringify(data);
      this.geometry = data.replace(/\'/g, '"');
      this.FnSearchRes(true);
    });
  }
  private PlotPolygon() {
    this.nearbySearchs.clearResourceLayer();
    this.nearbySearchs.DrawPolygon(1, (data: any) => {
      data = JSON.stringify(data);
      this.geometry = data.replace(/\'/g, '"');
      this.FnSearchRes(true);
    });
  }

  /**FnReasch
   * 搜索的方法
   */
  private FnReasch(): any {
    const data = {
      longitude: 127.528,
      latitude: 50.22,
    };
    const SearchEnterprisess = new SearchEnterprises();
    SearchEnterprisess.addPoints(data, '企业');
    SearchEnterprisess.addPolygon();
  }
  /**
   *  更多
   */
  private searchMore(): any {
    this.isSearching = !this.isSearching;
    this.selectDialog = false;
  }
  /**FnAginSearch
   * 再次搜索
   */
  private FnAginSearch(): any {
    this.isSearching = !this.isSearching;
    this.selectDialog = false;
  }

  // console.log(document.window)
  /**FnIsShow
   * 企业画像
   */
  private FnIsShow(id: any): any {
    $('.dialog').show();
    this.FnClickSearchRes(id);
    this.dialogTableVisiblearea = false;
    const SearchEnterprisesc = new SearchEnterprises();
    SearchEnterprisesc.clearTootip();
    SearchEnterprisesc.removehighlight();
    if (document.getElementById('entertool')) {
      $('#entertool').remove();
    }
  }
  /**FnSearchRes
   * 搜索服务
   */
  private FnSearchRes(flag: boolean): any {
    if (this.EnterpriseList.length === 0) {
      this.msgObj = this.$message('请选择分类');
      return;
    }
    let loading: any = '';
    this.messageBus.emit('legendIsShow', false);
    if (flag) {
      this.SearchResParams.nowPage = 1;
      this.SearchRes = [];
      loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    }
    this.loading = true;
    let strFreeTradeZone: any = '';
    let strIsKeyEnterprises: any = '';
    let strNotKeyEnterprises: any = '';
    let strEnterpriseType: any = '';
    let entrprises: any = '';
    for (const iterator of this.SearchResParamsForFreeTradeZone) {
      strFreeTradeZone = strFreeTradeZone + iterator + ',';
    }
    for (const iterator of this.SearchResParamsForCharacteristic) {
      switch (iterator) {
        case '内资':
          strEnterpriseType = strEnterpriseType + iterator + ',';
          break;
        case '外资':
          strEnterpriseType = strEnterpriseType + iterator + ',';
          break;
        case '1':
          strIsKeyEnterprises = strIsKeyEnterprises + 1 + ',';
          break;
        case '2':
          strNotKeyEnterprises = strNotKeyEnterprises + 2 + ',';
          break;
        default:
          break;
      }
    }
    for (const iterator of this.EnterpriseList) {
      entrprises = entrprises + iterator + ',';
    }
    const arrFreeTradeZone: any = strFreeTradeZone.split(',');
    const arrEnterpriseType: any = strEnterpriseType.split(',');
    const arrIsKeyEnterprises: any = strIsKeyEnterprises.split(',');
    const arrNotKeyEnterprises: any = strNotKeyEnterprises.split(',');
    const arrEntrprisesList: any = entrprises.split(',');
    const ArrarrFreeTradeZone: any = arrFreeTradeZone.map((x: any) => {
      for (const iterator of this.reasch.fta) {
        if (x === iterator.id) {
          x = iterator.label;
          return x;
        }
      }
    });
    let ArrarrIsKeyEnterprises: any = arrIsKeyEnterprises.map((x: any) => {
      for (const iterator of this.reasch.characteristic) {
        if (x === iterator.value) {
          x = iterator.label;
          return x;
        }
      }
    });

    const ArrarrNotKeyEnterprises: any = arrNotKeyEnterprises.map((x: any) => {
      for (const iterator of this.reasch.characteristic) {
        if (x === iterator.value) {
          x = iterator.label;
          return x;
        }
      }
    });
    const ArrarrEntrprisesList: any = arrEntrprisesList.map((x: any) => {
      for (const iterator of this.reasch.class) {
        if (x === iterator) {
          return x;
        }
      }
    });
    let ArraySelect: any = [];
    this.selectList.map((item: any) => {
      ArraySelect.push(item.label);
    });

    const arrOne: any = ArrarrFreeTradeZone.concat(ArrarrIsKeyEnterprises);
    const arrTwo: any = arrOne.concat(ArrarrNotKeyEnterprises);
    const arrClass: any = arrTwo.concat(ArrarrEntrprisesList);
    const arrSelect: any = arrClass.concat(arrEnterpriseType);
    const arrThree: any = arrSelect.concat(ArraySelect);

    this.wit = arrThree.filter((s: any) => {
      return s && s.trim();
    });
    const ARRisKeyEnterprises = ArrarrIsKeyEnterprises.concat( ArrarrNotKeyEnterprises);
    const deWeight = ARRisKeyEnterprises.filter((s: any) => {
      return s && s.trim();
    });
    let isKey = '';
    for (const iterator of deWeight) {
      if (iterator === '重点') {
        const word = '1';
        isKey = isKey + word + ',';
      } else {
        const word = '2';
        isKey = isKey + word;
      }
    }
    let classArr: any = [];
    const industryCode = classArr.concat(
      this.bigdefeatCheck,
      this.middefeatCheck,
      this.smalldefeatCheck,
    );

    // 判断类别
    let industryClassify: any = '';
    if (this.categoryListsmallSelect !== '') {
      industryClassify = this.categoryListsmallSelect;
    } else if (this.categoryListmidSelect !== '') {
      industryClassify = this.categoryListmidSelect;
    } else if (this.categoryListbigSelect !== '') {
      industryClassify = this.categoryListbigSelect;
    } else if (this.categoryListSelect !== '') {
      industryClassify = this.categoryListSelect;
    }

    // 企业分类
    const enterpriseClassifies = this.SearchResParamsForClassify;

    this.SearchResParams.freeTradeZone = strFreeTradeZone;
    this.SearchResParams.isKeyEnterprises = isKey;
    this.SearchResParams.enterpriseType = strEnterpriseType;
    this.SearchResParams.source = '1';
    this.SearchResParams.industryClass = this.defeatCheck.join(',');
    this.SearchResParams.industryCode = industryCode.join(',');
    this.SearchResParams.industryClassify = industryClassify;
    this.SearchResParams.enterpriseClassifies = enterpriseClassifies;
    // mapServer.searchEnterprise(this.SearchResParams).then((res: any) => {
    mapServer.getEnterpriseListByGeometry({
      creditCodeOrName: this.SearchResParams.creditCodeOrName,
      nowPage: this.SearchResParams.nowPage,
      pageSize: 10,
      geometry: this.geometry,
    }).then((res: any) => {
    // mapServer.searchEnterprise(this.SearchResParams).then((res: any) => {
      if (loading) {
        loading.close();
      }
      this.loading = false;
      if (this.msgObj) {
        this.msgObj.close(); // 关闭上一个this.$message实例
      }
      if (res.data.data.nowPage === 0 && res.data.data.list.length === 0) {
        this.SearchRes = [];
        this.msgObj = this.$message('暂无数据');
      } else if (res.data.data.list.length === 0) {
        this.SearchRes = [];
        this.msgObj = this.$message('暂无数据');
      } else {
        this.SearchRes = res.data.data.list;
      }
      this.nowPage = res.data.data.nowPage + 1;
      this.pageSize = res.data.data.pageSize;
      this.totalPages = res.data.data.pages;
      this.total = res.data.data.total;
      this.countNum = [{
        name: '企业',
        num: res.data.data.total,
      }];

      // let arrData: any = [];
      // arrData = this.SearchRes.concat(res.data.data.list);
      // this.SearchRes = arrData;
      const data = res.data.data.list;
      const SearchEnterprisess = new SearchEnterprises();
      this.isSearching = false;
      SearchEnterprisess.addPoints(this.SearchRes, '企业');
      this.dialogTableVisibleEnterpriseImage = false;
      this.dialogTableVisiblearea = false;
      SearchEnterprisess.clearAlldiv();
    });
    // mapServer.statisticsEnterprise(this.SearchResParams).then((res: any) => {
    //   if (res.data.status === 200) {
    //     // 展示企业分类统计
    //     this.$store.state.searchStore.enterpriseTypeCount = res.data.data;
    //   }
    // });
  }
  private handleInfoCurrentChange(data: any) {
    console.log('handleInfoCurrentChange');
    mapServer.getInfoPushList({
        endDate: '',
        enterpriseId: this.detailId,
        informationCode: '',
        nowPage: data,
        pageSize: 5,
        startDate: '',
        title: '',
        source: 1,
    }).then((res: any) => {
      if (res.data.status === 200) {
        this.tableData = res.data.data.list;
        this.totalInfoPage = res.data.data.pages;
        this.totalInfo = res.data.data.total;
      }
    });
  }

  private itemClick(item: any) {
    mapServer.getInfoPushDetail({
      informationId: item.informationId,
    }).then((res: any) => {
      if (res.data.status === 200) {
        this.showInfoPushDetail = res.data.data.content;
      }
    });
  }

  private changeTag(val: any) {
      this.tagVal = val;
  }

  /**FnClickSearchRes
   * 查看企业详情
   */
  private FnClickSearchRes(id: any): any {
    const self = this;
    this.tagVal = 1;
    const params: any = {
      enterpriseId: id,
    };
    self.detailId = id;
    mapServer.getInfoPushList({
        endDate: '',
        enterpriseId: id,
        informationCode: '',
        nowPage: 1,
        pageSize: 5,
        startDate: '',
        title: '',
        source: 1,
    }).then((res: any) => {
      if (res.data.status === 200) {
        self.tableData = res.data.data.list;
        self.totalInfoPage = res.data.data.pages;
        self.totalInfo = res.data.data.total;
      }
    });
    mapServer.FnClickSearchRes(params).then((res: any) => {
      this.dialogTableVisibleEnterpriseImage = true;
      this.dialogTableVisiblearea = false;
      this.enterpriseInfo = res.data.data;
      const SearchEnterprisehx = new SearchEnterprises();
      const data = res.data.data;
      SearchEnterprisehx.setPointCeter(data);
      // SearchEnterprisehx._addHighlight(
      //   data.longitude,
      //   data.latitude,
      //   data.isKeyEnterprisesName
      // );
    });
    this.AdDetail = {};
    this.img_list = [];
    mapServer.getAdByEnterpriseId({
      endDate: '',
      enterpriseId: id,
      nowPage: 1,
      pageSize: 9999,
      roleType: '',
      source: '1',
      startDate: '',
      stateFlag: '2',
      title: '',
    }).then((res: any) => {
      if (res.data.status === 200) {
        this.AdDetail = res.data.data.list[0];
        this.img_list = res.data.data.list[0].gisattachmentList;
      }
    });
  }

  /**FnGiveMap
   * 给GIS的数据
   */
  private FnGiveMap(data: any): void {
    const SearchEnterprisess = new SearchEnterprises();
    SearchEnterprisess.openPopup(data);
    SearchEnterprisess._addHighlight(
      data.longitude,
      data.latitude,
      data.isKeyEnterprisesName,
      '企业',
    );
  }

  /**FnLoad
   * 触底事件
   */
  private FnLoad(): void {
    // console.log('是否触发触底事件');
    this.SearchResParams.nowPage = this.SearchResParams.nowPage + 1;
    this.FnSearchRes(false);
  }

  /**FnClear
   * 清除方法
   */
  private FnClear(): void {
    this.SearchResParams = {
      creditCodeOrName: '',
      endTime: '',
      enterpriseId: '',
      enterpriseType: '',
      freeTradeZone: '',
      industryClass: '',
      industryCode: '',
      isKeyEnterprises: '',
      nowPage: 1,
      pageSize: 10,
      startTime: '',
    };
    this.wit = [];
    // this.isSearching = false;
    this.EnterpriseList = [];
    this.SearchResParamsForCharacteristic = [];
    this.SearchResParamsForFreeTradeZone = [];
    this.SearchRes = [];
    const SearchEnterprisesc = new SearchEnterprises();
    this.delAll();
    SearchEnterprisesc.clearAll();
  }
  // 企业门类 弹框选择功能 代码 --start
  private openTypeSelect(): void {
    this.selectDialog = true;
    this.dialogTableVisibleEnterpriseImage = false;
    this.dialogTableVisiblearea = false;
    this.isActive = true;
  }
  // 获取门类数据
  private getCategory(param: any) {
    mapServer.getCategory(param).then((res: any) => {
      if (res.data.status === 200) {
        let categoryArr: any = [];

        res.data.data.map((item: any) => {
          categoryArr.push({
            disabled: item.disabled,
            id: item.id,
            label: item.label,
            leaf: item.leaf,
            orgTypeCode: item.orgTypeCode,
            parentId: item.parentId,
            parentLabel: item.parentLabel,
            virtualNode: item.virtualNode,
            type: '门类',
          });
        });
        this.categoryList = categoryArr;
        // this.getChildrenCategory({ industrycode: this.categoryList[0].id });
      }
    });
  }
  private changeCategoryBigSelect(id: any) {
    let mid: any = [];
    this.categoryListmidSelect = '';
    this.categoryListsmallSelect = '';
    this.souceData.map((it: any) => {
      if (it.id === id) {
        if (it.children && it.children.length > 0) {
          it.children.map((item: any) => {
            mid.push({
              disabled: this.selectList.length === 5 ? true : item.disabled,
              id: item.id,
              label: item.label,
              leaf: item.leaf,
              orgTypeCode: item.orgTypeCode,
              parentId: item.parentId,
              parentLabel: item.parentLabel,
              virtualNode: item.virtualNode,
              type: '中类',
              children: item.children,
            });
          });
          this.categoryListmid = mid;
        } else {
          this.categoryListmid = [];
        }
      }
    });
  }
  private changeCategoryMidSelect(id: any) {
    let smallArr: any = [];
    this.categoryListsmallSelect = '';
    this.categoryListmid.map((it: any) => {
      if (it.id === id) {
        if (it.children && it.children.length > 0) {
          it.children.map((item: any) => {
            smallArr.push({
              disabled: this.selectList.length === 5 ? true : item.disabled,
              id: item.id,
              label: item.label,
              leaf: item.leaf,
              orgTypeCode: item.orgTypeCode,
              parentId: item.parentId,
              parentLabel: item.parentLabel,
              virtualNode: item.virtualNode,
              type: '小类',
            });
          });
          this.categoryListsmall = smallArr;
        } else {
          this.categoryListsmall = [];
        }
      }
    });
  }
  private getChildrenCategory(params: any) {
    this.categoryListsmallSelect = '';
    this.categoryListmidSelect = '';
    this.categoryListbigSelect = '';
    mapServer.getChildrenCategory(params).then((res: any) => {
      if (res.data.status === 200) {
        // 将大类节点存储
        this.souceData = res.data.data;
        let bigArr: any = [];
        this.souceData.map((item: any) => {
          bigArr.push({
            disabled: this.selectList.length === 5 ? true : item.disabled,
            id: item.id,
            label: item.label,
            leaf: item.leaf,
            orgTypeCode: item.orgTypeCode,
            parentId: item.parentId,
            parentLabel: item.parentLabel,
            virtualNode: item.virtualNode,
            type: '大类',
          });
          // 将小类的所有父节点存储
        });
        this.categoryListbig = bigArr;
        let mid: any = [];
        if (this.souceData[0].children && this.souceData[0].children.length) {
          this.souceData[0].children.map((item: any) => {
            mid.push({
              disabled: this.selectList.length === 5 ? true : item.disabled,
              id: item.id,
              label: item.label,
              leaf: item.leaf,
              orgTypeCode: item.orgTypeCode,
              parentId: item.parentId,
              parentLabel: item.parentLabel,
              virtualNode: item.virtualNode,
              type: '中类',
            });
          });

          this.categoryListmid = mid;
        } else {
          this.categoryListmid = [];
        }

        let smallArr: any = [];
        if (
          this.souceData[0].children &&
          this.souceData[0].children.length > 0 &&
          this.souceData[0].children[0].children &&
          this.souceData[0].children[0].children.length > 0
        ) {
          this.souceData[0].children[0].children.map((item: any) => {
            smallArr.push({
              disabled: this.selectList.length === 5 ? true : item.disabled,
              id: item.id,
              label: item.label,
              leaf: item.leaf,
              orgTypeCode: item.orgTypeCode,
              parentId: item.parentId,
              parentLabel: item.parentLabel,
              virtualNode: item.virtualNode,
              type: '小类',
            });
          });
          this.categoryListsmall = smallArr;
        } else {
          this.categoryListsmall = [];
        }
      }
    });
  }

  private add(): void {
    this.selectList = [];
    let arr: any = [];
    this.selectList = arr.concat(
      this.category,
      this.categorybig,
      this.categorymid,
      this.categorysmall,
    );
    this.selectDialog = false;
    if (this.selectList.length === 0) {
      this.isActive = false;
    }
  }

  private delAll(): void {
    this.isActive = false;
    this.selectList = [];
    // 四个树选中清空
    this.category = [];
    this.categorybig = [];
    this.categorymid = [];
    this.categorysmall = [];
    // 默认选中清空
    this.defeatCheck = [];
    this.bigdefeatCheck = [];
    this.middefeatCheck = [];
    this.smalldefeatCheck = [];
    this.category.map((item: any) => {
      item.disabled = false;
    });
    this.categorybig.map((item: any) => {
      item.disabled = false;
    });
    this.categorymid.map((item: any) => {
      item.disabled = false;
    });
    this.categorysmall.map((item: any) => {
      item.disabled = false;
    });
    this.selectDialog = false;
  }

  private deleted(data: any): void {
    const categoryTree = this.$refs.categoryTree as Tree;
    const bigTree = this.$refs.bigTree as Tree;
    const midTree = this.$refs.midTree as Tree;
    const smallTree = this.$refs.smallTree as Tree;
    let defeatArr: any = [];
    let listArr: any = [];
    let inBig = 0;
    let inmid = 0;
    let insmall = 0;
    switch (data.type) {
      case '门类':
        this.defeatCheck.map((item: any) => {
          if (item !== data.id) {
            defeatArr.push(item);
          }
        });
        this.defeatCheck = defeatArr;
        categoryTree.setCheckedKeys(this.defeatCheck, true);

        break;
      case '大类':
        this.categorybig.map((item: any) => {
          if (item.id !== data.id) {
            listArr.push(item);
            defeatArr.push(item.id);
          }
        });
        this.categoryListbig.map((items: any) => {
          if (items.id !== data.id) {
            inBig ++;
          }
        });
        this.bigdefeatCheck = defeatArr;
        bigTree.setCheckedKeys(this.bigdefeatCheck, true);
        if (inBig === this.categoryListbig.length) {
          this.categorybig = listArr;
          this.getSelectList();
        }
        break;
      case '中类':
        this.categorymid.map((item: any) => {
          if (item.id !== data.id) {
            listArr.push(item);
            defeatArr.push(item.id);
          }
        });
        this.categoryListmid.map((items: any) => {
          if (items.id === data.id) {
            inmid ++;
          }
        });
        this.middefeatCheck = defeatArr;
        midTree.setCheckedKeys(this.middefeatCheck, true);
        if (!inmid) {
          this.categorymid = listArr;
          this.getSelectList();
        }
        break;
      case '小类':
        this.categorysmall.map((item: any) => {
          if (item.id !== data.id) {
            listArr.push(item);
            defeatArr.push(item.id);
          }
        });
        this.categoryListsmall.map((items: any) => {
          if (items.id === data.id) {
            insmall ++;
          }
        });
        this.smalldefeatCheck = defeatArr;
        smallTree.setCheckedKeys(this.smalldefeatCheck, true);
        if (!insmall) {
          this.categorysmall = listArr;
          this.getSelectList();
        }
        break;
    }
    this.updateLimit();
  }
  // 门类选中改变
  private categoryChange(val: any): void {
    this.getChildrenCategory({ industrycode: val.id });
  }
  // 选中
  private categoryChecked(val: any): void {
    let flag = true;
    if (this.category.length > 0) {
      this.category.map((item: any) => {
        if (val.id === item.id) {
          flag = false;
        }
      });
      if (flag) {
        this.category.push(val);
        this.defeatCheck.push(val.id);
      } else {
        let arr: any = [];
        let idArr: any = [];
        this.category.map((item: any) => {
          if (val.label !== item.label) {
            arr.push(item);
            idArr.push(item.id);
          }
        });
        this.category = arr;
        this.defeatCheck = idArr;
      }
    } else {
      this.category.push(val);
      this.defeatCheck.push(val.id);
    }
    this.getSelectList();
    // let arr: any = [];
    // this.selectList = arr.concat(
    //   this.category,
    //   this.categorybig,
    //   this.categorymid,
    //   this.categorysmall
    // );
    this.updateLimit();
  }
  // 大类选中改变
  private categorybigChange(val: any): void {
    console.log('大类', val);
    this.changeChildren(val, 'big');
  }
  // 选中
  private categorybigChecked(val: any): void {
    let flag = true;
    if (this.categorybig.length > 0) {
      this.categorybig.map((item: any) => {
        if (val.label === item.label) {
          flag = false;
        }
      });
      if (flag) {
        this.categorybig.push(val);
        this.bigdefeatCheck.push(val.id);
      } else {
        let arr: any = [];
        let idArr: any = [];
        this.categorybig.map((item: any) => {
          if (val.label !== item.label) {
            arr.push(item);
            idArr.push(item.id);
          }
        });
        this.categorybig = arr;
        this.bigdefeatCheck = idArr;
      }
    } else {
      this.categorybig.push(val);
      this.bigdefeatCheck.push(val.id);
    }
    this.getSelectList();
    this.updateLimit();
  }
  // 中类选中改变
  private categorymidChange(val: any): void {
    this.changeChildren(val, 'mid');
  }
  // 中类选中
  private categorymidChecked(val: any): void {
    let flag = true;
    if (this.categorymid.length > 0) {
      this.categorymid.map((item: any) => {
        if (val.label === item.label) {
          flag = false;
        }
      });
      if (flag) {
        this.categorymid.push(val);
        this.middefeatCheck.push(val.id);
      } else {
        let arr: any = [];
        let idArr: any = [];
        this.categorymid.map((item: any) => {
          if (val.label !== item.label) {
            arr.push(item);
            idArr.push(item.id);
          }
        });
        this.categorymid = arr;
        this.middefeatCheck = idArr;
      }
    } else {
      this.categorymid.push(val);
      this.middefeatCheck.push(val.id);
    }
    this.getSelectList();
    this.updateLimit();
  }
  // 小类选中
  private categorysmallChecked(val: any): void {
    let flag = true;
    if (this.categorysmall.length > 0) {
      this.categorysmall.map((item: any) => {
        if (val.label === item.label) {
          flag = false;
        }
      });
      if (flag) {
        this.categorysmall.push(val);
        this.smalldefeatCheck.push(val.id);
      } else {
        let arr: any = [];
        let idArr: any = [];
        this.categorysmall.map((item: any) => {
          if (val.label !== item.label) {
            arr.push(item);
            idArr.push(item.id);
          }
        });
        this.categorysmall = arr;
        this.smalldefeatCheck = idArr;
      }
    } else {
      this.categorysmall.push(val);
      this.smalldefeatCheck.push(val.id);
    }
    this.getSelectList();
    this.updateLimit();
  }
  // 子节点内容挑选
  private changeChildren(data: any, type: any): void {
    if (type === 'big') {
      this.souceData.map((item: any) => {
        if (data.id === item.id) {
          let newArr: any = [];
          if (item.children && item.children.length > 0) {
            item.children.map((item: any) => {
              newArr.push({
                disabled: this.selectList.length === 5 ? true : item.disabled,
                id: item.id,
                label: item.label,
                leaf: item.leaf,
                orgTypeCode: item.orgTypeCode,
                parentId: item.parentId,
                parentLabel: item.parentLabel,
                virtualNode: item.virtualNode,
                type: '中类',
              });
            });
            this.categoryListmid = newArr;
          } else {
            this.categoryListmid = [];
          }
          let myArr: any = [];
          if (
            item.children[0].children &&
            item.children[0].children.length > 0
          ) {
            item.children[0].children.map((item: any) => {
              myArr.push({
                disabled: this.selectList.length === 5 ? true : item.disabled,
                id: item.id,
                label: item.label,
                leaf: item.leaf,
                orgTypeCode: item.orgTypeCode,
                parentId: item.parentId,
                parentLabel: item.parentLabel,
                virtualNode: item.virtualNode,
                type: '小类',
              });
            });
            this.categoryListsmall = myArr;
          } else {
            this.categoryListsmall = [];
          }
        }
      });
    } else if (type === 'mid') {
      let targetArr: any = [];
      this.souceData.map((item: any) => {
        if (data.parentId === item.id) {
          targetArr = item.children;
          targetArr.map((child: any) => {
            if (data.id === child.id) {
              let disArr: any = [];
              if (item.children && item.children.length > 0) {
                child.children.map((item: any) => {
                  disArr.push({
                    disabled:
                      this.selectList.length === 5 ? true : item.disabled,
                    id: item.id,
                    label: item.label,
                    leaf: item.leaf,
                    orgTypeCode: item.orgTypeCode,
                    parentId: item.parentId,
                    parentLabel: item.parentLabel,
                    virtualNode: item.virtualNode,
                    type: '小类',
                  });
                });
                this.categoryListsmall = disArr;
              } else {
                this.categoryListsmall = [];
              }
            }
          });
        }
      });
    }
  }
  // 最大长度限制
  private updateLimit() {
    let Arr: any = [];
    const source = Arr.concat(
      this.category,
      this.categorybig,
      this.categorymid,
      this.categorysmall,
    );
    if (source.length === 5) {
      if (this.category.length > 0) {
        this.changeDiasable(this.categoryList, this.category);
      } else {
        this.categoryList.map((item: any) => {
          item.disabled = true;
        });
      }

      if (this.categorybig.length > 0) {
        this.changeDiasable(this.categoryListbig, this.categorybig);
      } else {
        this.categoryListbig.map((item: any) => {
          item.disabled = true;
        });
      }
      if (this.categorymid.length > 0) {
        this.changeDiasable(this.categoryListmid, this.categorymid);
      } else {
        this.categoryListmid.map((item: any) => {
          item.disabled = true;
        });
      }

      if (this.categorysmall.length > 0) {
        this.changeDiasable(this.categoryListsmall, this.categorysmall);
      } else {
        this.categoryListsmall.map((item: any) => {
          item.disabled = true;
        });
      }
    } else {
      this.categoryList.map((item: any) => {
        item.disabled = false;
      });
      this.categoryListbig.map((item: any) => {
        item.disabled = false;
      });
      this.categoryListmid.map((item: any) => {
        item.disabled = false;
      });
      this.categoryListsmall.map((item: any) => {
        item.disabled = false;
      });
    }
  }
  // 选中状态更改
  private changeDiasable(source: any, target: any) {
    source.map((item: any) => {
      let flag = false;
      for (let i = 0; i < target.length; i++) {
        if (item.id === target[i].id) {
          flag = true;
        }
      }
      if (flag) {
        item.disabled = false;
      } else {
        item.disabled = true;
      }
    });
  }
  // 整理已选列表数据
  private getSelectList(): void {
    let arr: any = [];
    this.selectList = arr.concat(
        this.category,
        this.categorybig,
        this.categorymid,
        this.categorysmall,
      );
  }
  // 企业门类 弹框选择功能 代码 --end
  private FnGetLegendData(): void {
    const params: any = {};
    mapServer.FnGetLegend(params).then((res: any) => {
      this.legendData = res.data.data;
      const data = res.data.data;
      const SearchEnterpriseqh = new SearchEnterprises();
      this.SearchEnterpriseqh = SearchEnterpriseqh;
      // SearchEnterpriseqh.addPolygon(data);
    });
  }
  private FnIsShowFalg(): void {
    this.minFalg = !this.minFalg;
  }
  private FnIsShowEye(info: any, index: any): void {
    this.dialogTableVisibleEnterpriseImage = false;
    this.$set(this.eyeFlag, index, !this.eyeFlag[index]);
    // console.log('info', info);
    const data = info.freeTradeZoneCode;
    const Flag = this.eyeFlag[index];
    const SearchEnterpriseyy = new SearchEnterprises();
    // SearchEnterpriseyy.setLayerVisible(data, Flag);
    SearchEnterpriseyy.setPolline(info, Flag);

    // this.minFalg = false;
  }
  private FnIsShowTitle(data: any): void {
    const name = data.freeTradeZoneName;
    const SearchEnterprisesy = new SearchEnterprises();
    SearchEnterprisesy.setCenterPolygon(data, name);
  }
  private FnGetAreaInfo(areaInfo: any): void {
    this.areaInfo.title = areaInfo.freeTradeZoneName;
    this.areaInfo.info = areaInfo.content;
    this.dialogTableVisiblearea = true;
    this.dialogTableVisibleEnterpriseImage = false;
    const SearchEnterprisesc = new SearchEnterprises();
    SearchEnterprisesc.clearTootip();
    SearchEnterprisesc.removehighlight();
    if (document.getElementById('entertool')) {
      $('#entertool').remove();
    }
    // this.minFalg = false;
  }
  private created() {
    this.getArea();
    this.getAnterpriseClassify();
  }
  private mounted() {
    this.FnGetLegendData();
    this.getCategory({});
    this.messageBus.on('legendIsShow', (res: any) => {
      this.minFalg = res;
    });

    const nearbySearchs = new nearbySearch();
    nearbySearchs.load();
    this.nearbySearchs = nearbySearchs;

    this.messageBus.on('openEnterprisePopup', (res: any) => {
      this.FnIsShow(res.enterpriseId);
    });
  }

  private beforeDestroy() {
    this.SearchEnterpriseqh.clearAll();
    this.SearchEnterpriseqh.clearTootip();
    this.nearbySearchs.destroy();
  }

  private getArea() {
    mapServer.getArea().then((res: any) => {
      if (res.data.status === 200) {
        this.reasch.fta = res.data.data;
      }
    });
  }
  private getAnterpriseClassify() {
    mapServer.getAnterpriseClassify().then((res: any) => {
      if (res.data.status === 200) {
        this.reasch.classify = res.data.data;
      }
    });
  }
}
